exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".module-statements-list .list-empty {\n  padding: 16px 0;\n  text-align: center;\n}\n", ""]);

